import { useLocation } from 'react-router-dom';

export function useEmrContext() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return {
    external_patient_id:   params.get('external_patient_id')   || '',
    external_admission_id: params.get('external_admission_id') || '',
    doctor_id:             params.get('doctor_id')             || '',
    ward_id:               params.get('ward_id')               || '',
    department_id:         params.get('department_id')         || '',
  };
}
